import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseDataBody } from 'src/types/websocket'

const initialState: ResponseDataBody.DeviceAuth = {
  File: false,
  Camera: false,
  Location: false,
}

const DeviceAuthSlice = createSlice({
  name: 'deviceAuth',
  initialState,
  reducers: {
    setDeviceAuth(state, action: PayloadAction<ResponseDataBody.DeviceAuth>) {
      const { Camera, Location, File } = action.payload
      state.File = File
      state.Location = Location
      state.Camera = Camera
    },
  },
})

export const { setDeviceAuth } = DeviceAuthSlice.actions

export default DeviceAuthSlice.reducer
